import { render, staticRenderFns } from "./InvoiceHeader.vue?vue&type=template&id=7579f4c3&scoped=true&"
import script from "./InvoiceHeader.vue?vue&type=script&lang=js&"
export * from "./InvoiceHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7579f4c3",
  null
  
)

export default component.exports